var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcModalidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7083 6.875H6.875C6.2674 6.87561 5.68486 7.11724 5.25522 7.54688C4.82558 7.97652 4.58394 8.55906 4.58333 9.16667V13.75H6.875V9.16667H52.7083V38.9583H20.625V41.25H25.2083V43.5417H22.9167V45.8333H36.6667V43.5417H34.375V41.25H52.7083C53.3159 41.2494 53.8985 41.0078 54.3281 40.5781C54.7578 40.1485 54.9994 39.5659 55 38.9583V9.16667C54.9994 8.55906 54.7578 7.97652 54.3281 7.54688C53.8985 7.11724 53.3159 6.87561 52.7083 6.875ZM32.0833 43.5417H27.5V41.25H32.0833V43.5417ZM16.6146 16.0417H1.71875C1.2631 16.0423 0.826277 16.2235 0.50408 16.5457C0.181883 16.8679 0.000606328 17.3048 0 17.7604L0 48.6979C0.000606328 49.1536 0.181883 49.5904 0.50408 49.9126C0.826277 50.2348 1.2631 50.4161 1.71875 50.4167H16.6146C17.0702 50.4161 17.5071 50.2348 17.8293 49.9126C18.1515 49.5904 18.3327 49.1536 18.3333 48.6979V17.7604C18.3327 17.3048 18.1515 16.8679 17.8293 16.5457C17.5071 16.2235 17.0702 16.0423 16.6146 16.0417ZM16.0417 48.125H2.29167V18.3333H16.0417V48.125ZM13.75 22.9167H4.58333V20.625H13.75V22.9167ZM13.75 27.5H4.58333V25.2083H13.75V27.5ZM13.75 32.0833H4.58333V29.7917H13.75V32.0833ZM11.4583 34.375H13.75V36.6667H11.4583V34.375Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModalidad);
export default __webpack_public_path__ + "static/media/ic_modalidad.91e68bcd2cc7f01c60c819b184c50794.svg";
export { ForwardRef as ReactComponent };